interface TabletTextProps {
  children: string;
}

const TabletSubText: React.FC<TabletTextProps> = ({ children }) => {
  const text =
    children?.length >= 17 ? `${children?.slice(0, 17)}...` : children;

  return (
    <span className="text-sm leading-5 font-medium text-gray-500">{text}</span>
  );
};

export default TabletSubText;
